import React from 'react';

import { isIOSDevice, isInstalledWebApp } from '../lib/push-capabilities.js';

// iOS Safari has no programmatic install prompt; explain its native install flow.
export default class IphoneInstall extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {expanded: false};
  }

  render() {
    if (!isIOSDevice() || isInstalledWebApp()) {
      return null;
    }

    return (
      <section className="vibe-iphone-install" aria-label="Установка Vibe на iPhone">
        <button type="button" className="vibe-iphone-install-trigger"
          aria-expanded={this.state.expanded}
          onClick={() => this.setState(state => ({expanded: !state.expanded}))}>
          <span className="vibe-iphone-install-icon"><i className="material-icons" aria-hidden="true">ios_share</i></span>
          <span className="vibe-iphone-install-copy">
            <strong>Установить Vibe</strong>
            <small>Добавить на главный экран iPhone</small>
          </span>
          <i className="material-icons vibe-iphone-install-chevron" aria-hidden="true">
            {this.state.expanded ? 'expand_less' : 'chevron_right'}
          </i>
        </button>
        {this.state.expanded && <div className="vibe-iphone-install-details">
          <ol>
            <li>Откройте эту страницу в <strong>Safari</strong>.</li>
            <li>Нажмите <strong>«Поделиться»</strong> <i className="material-icons" aria-label="Поделиться">ios_share</i>.</li>
            <li>Выберите <strong>«На экран Домой»</strong>, затем нажмите <strong>«Добавить»</strong>.</li>
            <li>Запустите Vibe с новой иконки на экране «Домой».</li>
          </ol>
          <p>Vibe откроется отдельно, как приложение. Для push-уведомлений требуется iOS 16.4 или новее.</p>
          <button type="button" className="vibe-iphone-install-done"
            onClick={() => this.setState({expanded: false})}>Понятно</button>
        </div>}
      </section>
    );
  }
}
